module.exports = "<div class=\"container-fluid\">\n\n</div>"